"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { initAppInsights } from "@/lib/appInsights";
export default function useAppInsights(connectionString, roleName) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== connectionString || $[1] !== roleName) {
    t0 = () => {
      if (!connectionString || !roleName) {
        return;
      }
      initAppInsights(connectionString, roleName);
    };
    t1 = [connectionString, roleName];
    $[0] = connectionString;
    $[1] = roleName;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}